<template>
    <ActivityDetailsCard activityType="Compensation" :title="title" :entity="item.entity">
        <template #sub-header>
            <div class="cell wide">
                <h5>Company</h5>
                <span>{{ company.name }}</span>
            </div>

            <div class="cell">
                <h5>Ticker</h5>
                <span>{{ company.symbol }}</span>
            </div>
            <div class="cell">
                <h5>Fiscal Year</h5>
                <span>
                    <a :href="filingLink" target="_blank">{{ compensation.fiscalYear }}</a>
                </span>
            </div>

            <div class="cell">
                <h5>Date</h5>
                <span>{{ effectiveDate }}</span>
            </div>
            <div class="cell">
                <h5>Total</h5>
                <span>{{ totalDisplay }}</span>
            </div>
        </template>

        <ProfileSection title="Details">
            <template #view-all>
                <router-link
                    :to="{ name: 'executive-page', params: { id: item.entity.id }, query: { tab: 'Compensation' } }"
                    >VIEW ALL &gt;</router-link
                >
            </template>
            <CompensationDonutChart :categories="categories" :showValues="true" :total="compensation.total" />
        </ProfileSection>

        <ActivityStockPriceLine :item="item" />
    </ActivityDetailsCard>
</template>

<script setup>
import ProfileSection from '@/components/shared/profile-section'
import { compensationFormats } from '@/utils/format'
import { arrayify } from '@/services/compensationService'
import ActivityDetailsCard from './ActivityDetailsCard.vue'
import ActivityStockPriceLine from './ActivityStockPriceLine.vue'
import CompensationDonutChart from '@/pages/ExecutivePage/CompensationTab/CompensationDonutChart.vue'

import { computed } from 'vue'

const props = defineProps({
    item: {
        type: Object,
        required: true,
    },
})

const compensation = computed(() => props.item.details.compensation)
const categories = computed(() => arrayify(compensation.value))
const effectiveDate = computed(() => new Date(props.item.effectiveDate).toLocaleDateString())
const filingLink = computed(() => `/sec/filings/${compensation.value.accessionNumber}?table=summaryCompensation`)
const title = computed(() => `Fiscal Year ${compensation.value.fiscalYear}`)
const totalDisplay = computed(() => compensationFormats.currency(compensation.value.total))
const company = computed(() => props.item.details.company)
</script>
